<!-- 微业贷-->
<template>
  <div class="microEnterpriseLoan">
    <div v-if="app" class="top cardShell">
      <h3 class="title">企业爱普APP申请</h3>
      <div class="center">
        <a class="download" href="https://www.webank.com/h5/#/product/enterpriseapp">下载企业爱普APP</a>
        <span class="text">，扫描二维码完成申请</span>
      </div>
      <van-button
        text="获取企业爱普二维码"
        type="danger"
        class="goNext"
        size="large"
        @click="getCode"
      />
    </div>
    <div v-if="mp" class="bottom cardShell">
      <h3 class="title">微信公众号申请</h3>
      <div class="center">
        <span class="text">点击下一步继续申请</span>
      </div>
      <van-button
        text="下一步"
        type="danger"
        class="goNext"
        size="large"
        @click="jumpTheThirdPartyAddress"
      />
    </div>
   <Popup v-model="isShowPopup" title="企业爱普APP申请二维码" :isClose="true" :imageBox="imageBox" btnText="保存">
    <div class="authenPopupBox">
      <div class="authenPopupText">
        <CreateQrCode :qrCodeurl="qrCodeurl" :generateImg="generateImg" />
      </div>
    </div>
  </Popup>
  </div>
</template>

<script>
import { Toast } from 'vant';
import Popup from './components/WeiqiPopup.vue';
import CreateQrCode from './components/CreateQrCode.vue';

export default {
  name: 'microEnterpriseLoan',
  data() {
    return {
      isShowPopup: false,
      mp: true,
      app: true,
      imageBox: null,
      qrCodeurl: '',
    };
  },
  components: {
    Popup,
    CreateQrCode,
  },
  mounted() {
    // 获取显示的模块
    const { productId } = this.$route.query;
    this.$api.CommonForms.getUiConfig({
      productId,
      pageId: 7,
    }).then((res) => {
      if (res.success) {
        const data = JSON.parse(res.data[0].productConfigs);
        data.forEach((item) => {
          if (item.key === 'app') {
            this.app = item.value;
          }
          if (item.key === 'mp') {
            this.mp = item.value;
          }
        });
      } else {
        Toast(res.returnMessage);
      }
    }).catch((e) => {
      console.log(e);
    });
  },
  methods: {
    getCode() {
      // this.$loading.show();
      this.imageBox = null;
      this.qrCodeurl = '';
      const { orderId } = this.$route.query;
      this.$api.CommonForms.getScanCode({ orderId }).then((res) => {
        if (res.success) {
          const {
            url,
          } = res.data;
          this.qrCodeurl = url;
        } else {
          Toast(res.returnMessage);
        }
        this.$loading.hide();
      }).catch(() => {
        this.$loading.hide();
      });
      this.isShowPopup = true;
    },
    generateImg(val) {
      this.imageBox = val;
    },
    // 页面跳转
    jumpTheThirdPartyAddress() {
      const { orderId } = this.$route.query;
      this.$api.CommonForms.getWeBankURL({ orderId }).then((res) => {
        if (res.success) {
          window.location.href = res.data.url;
        } else {
          Toast(res.returnMessage);
        }
      });
    },
  },
};
</script>
<style scoped>
.microEnterpriseLoan{
  width: 100%;
  height:100%;
  overflow: hidden;
}
.cardShell {
  box-sizing: border-box;
  padding-right: 15px;
  padding-left: 15px;
  background: #fff;
  padding-top: 10px;
  padding-bottom: 10px;
}
>>> .van-button--large{
    width: 100%;
    height: 37px;
}
.title{
  font-size: 14px;
}
.download{
  cursor: pointer;
  font-size: 12px;
  color: rgba(42, 130, 228, 1)
}
.bottom{
  margin-top: 20px;
}
.text{
  font-size: 12px;
  color: rgba(166, 166, 166, 1);
}
.center{
  margin: 20px 0;
}
.goNext{
  background: #f55348;
  font-weight: bold;
}
</style>
